// extracted by mini-css-extract-plugin
module.exports = {"containerDocNumber":"styles_containerDocNumber__32n1H"};